module.exports = __webpack_public_path__ + "img/6.496895eb.jpg";